import { useEffect, useRef, useState } from "react";
import { hush } from "@/lib/hush";

// The Held Breath — when the visitor reaches "Will you enter?", the void dims
// and the light stills for one long beat, then everything releases and the
// journey resumes into the marquee.
const IN = 0.9;
const HOLD = 0.6;
const OUT = 1.3;
const TOTAL = IN + HOLD + OUT;
const PEAK_DIM = 0.42;

export default function HeldBreath() {
  const [dim, setDim] = useState(0);
  const rafRef = useRef(0);
  const runningRef = useRef(false);

  useEffect(() => {
    const easeOut = (x) => 1 - Math.pow(1 - x, 3);
    const easeIn = (x) => x * x * x;
    const run = () => {
      if (runningRef.current) return;
      runningRef.current = true;
      const t0 = performance.now();
      const step = (now) => {
        const s = (now - t0) / 1000;
        let k;
        if (s < IN) k = easeOut(s / IN);
        else if (s < IN + HOLD) k = 1;
        else if (s < TOTAL) k = 1 - easeIn((s - IN - HOLD) / OUT);
        else k = 0;
        hush.k = k;
        setDim(k * PEAK_DIM);
        if (s < TOTAL) {
          rafRef.current = requestAnimationFrame(step);
        } else {
          hush.k = 0;
          setDim(0);
          runningRef.current = false;
        }
      };
      rafRef.current = requestAnimationFrame(step);
    };
    const onBreath = () => run();
    window.addEventListener("prism:held-breath", onBreath);
    return () => {
      window.removeEventListener("prism:held-breath", onBreath);
      cancelAnimationFrame(rafRef.current);
      hush.k = 0;
    };
  }, []);

  return (
    <div
      data-testid="held-breath-veil"
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[25] bg-[#030305]"
      style={{ opacity: dim, transition: "opacity 120ms linear" }}
    />
  );
}
